module.exports = __webpack_public_path__ + "fonts/D-DIN-PRO-700-Bold.ad1ee8fd.otf";